<!--
 * @Description: 访客计划 -- 新增页面
 * @Author: mdb
 * @Date: 2022-07-19 11:12:06
 * @LastEditTime: 2022-09-07 16:08:53
 * @LastEditors: mdb
-->
<template>
  <CosLayoutMain>
    <template #content>
      <VisitorProgramForm
        ref="visitorProgramFormRef"
        title="访客计划"
        v-model:value="dataForm"
        :saleChanceRefId="saleChanceRefId"
        @update:value="fetch"
      />
    </template>
    <template #footer>
      <a-button @click="goBack()">取消</a-button>
      <a-button :loading="loading" @click="handleReset()">重置</a-button>
      <a-button v-permission="'lbu_visitor_add_btn'" type="primary" :loading="loading" @click="handleSubmit()"
        >保存</a-button
      >
    </template>
  </CosLayoutMain>
</template>

<script setup lang="ts">
import { ref, reactive, toRaw, watch } from 'vue'
import { useRoute } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import { goBack } from '@/hooks/cosRouter'
import VisitorProgramForm from '../components/VisitorProgramForm.vue'
import { visitorProgramCreateOrUpdate } from '@/api/yuntuSales/followUpManage'
import type { LbuVisitorProgramEditParams } from '@/typings/api/followUpManage'
import dayjs from 'dayjs'

const route = useRoute()

const dataForm = reactive<LbuVisitorProgramEditParams>({
  remindType: 3
})

// 监听是否是从跟进记录页面跳转过来
const saleChanceRefId = ref()
watch(
  () => route.query.saleChanceRefId,
  (val) => {
    if (val) {
      dataForm.visitRefId = val as string
      saleChanceRefId.value = val as string
    }
  },
  { immediate: true }
)

const fetch = (val: any) => {
  Object.assign(dataForm, val)

  if (dataForm.startTime === undefined) {
    dataForm.startTime = dayjs().format('YYYY/MM/DD HH:mm:ss')
    dataForm.endTime = dataForm.startTime
  }
}

const visitorProgramFormRef = ref()
const handleReset = () => {
  visitorProgramFormRef.value?.resetFields()
}
const loading = ref(false)
const handleSubmit = () => {
  visitorProgramFormRef.value?.validate().then(() => {
    loading.value = true
    const params = toRaw(dataForm)
    visitorProgramCreateOrUpdate(params)
      .then(() => {
        message.success('新增成功')
        visitorProgramFormRef.value?.resetFields()
        goBack()
      })
      .finally(() => {
        loading.value = false
      })
  })
}
</script>
<script lang="ts">
export default { name: 'DcCosLbuVisitorProgramAdd' }
</script>

<style scoped></style>
